import { Button } from '@bancobarigui/barihaus';

interface ActionButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  cancelText?: string;
  saveText?: string;
  saveDisabled?: boolean;
  saveLoading?: boolean;
}

export function ActionButtons({
  onCancel,
  onSave,
  cancelText = 'Cancelar',
  saveText = 'Salvar',
  saveDisabled = false,
  saveLoading = false,
}: ActionButtonsProps) {
  return (
    <div className="flex justify-end gap-4">
      <Button size="large" onClick={onCancel}>
        {cancelText}
      </Button>
      <Button
        buttonColor="primary"
        size="large"
        onClick={onSave}
        disabled={saveDisabled}
        loading={saveLoading}
      >
        {saveText}
      </Button>
    </div>
  );
}

